// glonet.ai nexus constants (seeded 2026-07-02; see src/glonetai/db/).
export const GLONET_AI_EVENT_ID = 188;
export const GLONET_VOICE_AGENT_ID = "agent_5401kwh4m609f2080xbean73a6cd";
// the lounge SCREEN AGENT (formerly billboard agent — same agent, repurposed)
export const GLONET_SCREEN_AGENT_ID = "agent_4301kwr9459xe5htvk502h9qw7s4";
// /hosts "tell us about your audience" dictation (created 2026-07-10;
// src/glonetai/agent/create_host_intake_agent.py)
export const GLONET_HOST_INTAKE_AGENT_ID = "agent_6601kx5rjhy3fbqrd1abkz9m4qyz";
// /affiliates "apply for a founding slot" voice intake (create_affiliate_intake_agent.py)
export const GLONET_AFFILIATE_INTAKE_AGENT_ID = "agent_9501kyaz5x64etk9x2cjbbx32byb";
// /ops "the voice agent that runs the day" — reads one person's morning brief
// and acts on the cards they answer (create_ops_agent.py, 2026-08-12).
// Its whole knowledge is the {{brief}} dynamic variable, composed server-side.
export const GLONET_OPS_AGENT_ID = "agent_9401kzttypt6fa7a8nvxwm0ph87q";
